<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/pest-step2')"></span>
    </div>
    <div class="title">请选择您的房型</div>
    <!-- <img class="prepay-img" src='../../assets/img/other/prepaid50.png'> -->
    <br>
		<div class="main clearfix">

      <div class="cell" @click="orderSkipEditAndUpdate('house_type','house','/pest-step3-house')">
        <img src="../../assets/img/clean/type/house.svg">
        <div>House<br><span>独立别墅</span></div>
      </div>

      <div class="cell" @click="order.data.room_qty=3;orderUpdate('house_type','townhouse');showModal=true">
        <img src="../../assets/img/clean/type/townhouse.svg">
        <div>Town House<br><span>联排别墅</span></div>
      </div>

			<div class="cell last" @click="order.data.room_qty=2;orderUpdate('house_type','apartment');showModal=true">
				<img src="../../assets/img/clean/type/apartment.svg">
				<div>Apartment<br><span>电梯公寓</span></div>
			</div>

			<div class="cell last" @click="orderUpdate('room_qty','1');orderUpdate('extra_area','');orderUpdate('extra_granny','');orderUpdate('house_type','studio','/pest-step4')">
				<img src="../../assets/img/clean/type/studio.svg">
				<div>Studio<br><span>无客厅套房</span></div>
			</div>
		</div>

    <transition name="fade">
      <v-modal  v-if="showModal" @close="showModal = false">
        <div slot="body">
          <div class="modal-title">整屋房间数</div>


          <div class="info-box">
              <div >
                <br>
                <v-counter @plus="plus" @minus="minus" :num='order.data.room_qty' type='carpet'>
                <span slot="label">房间数</span>
                </v-counter>
                <br>
              </div>
          </div>

          <div class="btn-box">
            <div class="btn" :class="{ active: true}" @click="submitNext()">下一步</div>
          </div>
        </div>
      </v-modal>
    </transition>

    <img :src="pixelURL('pest','huxing')" class="hide">
  </div>


</template>

<script>
export default {
  name: 'pest-step1',
  data () {
    return {
      order:{},
      showModal:false
    }
  },
  methods: {
    submitNext: function () {
      this.orderUpdate('extra_area','');
      this.orderUpdate('extra_granny','');
      this.orderUpdateAll('/pest-step4');
    },
    plus: function (res) {
      this.order.data.room_qty = this.order.data.room_qty+1;
      if(this.order.data.room_qty > 6){
        this.order.data.room_qty = 6;
      }
    },
    minus: function (res) {
      this.order.data.room_qty = this.order.data.room_qty-1;
      if(this.order.data.room_qty < 1){
        this.order.data.room_qty = 1;
      }
    },
  },
  components: {
  },
  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedPest){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedPest;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
      if(localStorage.order){
        let localParsed = JSON.parse(localStorage.order);
        if(localParsed.service != "pest"){
          localStorage.order = localStorage.savedPest;
        }
      }
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "pest"){
        this.order = localParsed;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.multilayer{
	text-align:center;
	margin:20px 0;
}

.info-box{
	min-height:60px;
	padding-top:13px;
}

.info{
	font-weight:100;
	text-align:center;
	padding-top:4px;
}

.btn{
  width: 250px;
  height: 50px;
	margin-top:10px;
	background: #ddd;
	color:#666;
}
.btn.active{
  color:#fff;
	background: rgb(237,121,75);
	background: linear-gradient(90deg, #ff7444 0%,#fe9567 100%);
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}

.main{
  padding:0 30px 30px 30px;
}
.cell{
	float:left;
	width:50%;
	border-bottom:1px solid #DDD;
	box-sizing: border-box;
	height: 130px;
	text-align: center;
	cursor: pointer;
}
.cell:active{
	background: #eee;
}
.cell:nth-child(odd) {
	border-right:1px solid #DDD;
}
.cell.last{
	border-bottom:0;
  padding-top:10px;
}
.cell img{
	width:60px;
}

.cell div{
	margin-top:4px;
	color:#595D68;
  line-height:1.3;
  span{
    font-size:0.84em;
  }
}
.fade-enter {
  opacity: 0;
}

.fade-leave-active {
  opacity: 0;
}

.fade-enter .modal-container,
.fade-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.option-btn{
  border:2px solid #fe9567;
  border-radius:4px;
  min-width:68px;
	padding:0 8px;
  height:34px;
  line-height:34px;
  color:#ff7444;
  display:inline-block;
  margin:0 4px;
	text-align:center;
}

.option-btn.active{
  border:2px solid #fe9567;
  border-radius:4px;
  width:68px;
  height:34px;
  line-height:34px;
  background-color:#fe9567;
  color:#fff;
  display:inline-block;
  margin:0 4px;
	-webkit-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
	-moz-box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
  box-shadow: 0 10px 16px -10px rgba(237,121,75,0.8);
}


.prepay-img{
  width:100%;
}



</style>



// WEBPACK FOOTER //
// src/pages/pest/step3.vue